import React, { Suspense, useEffect, useLayoutEffect, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import Header from "../HomeSections/Header";
import SiteFooter from "../HomeSections/SiteFooter";
import { translations } from "../../utils/homeContent";

const components = {
  es: React.lazy(() => import("./GDPRSpanish")),
  en: React.lazy(() => import("./GDPREnglish")),
};

const GDPR = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [isLoginOpen, setIsLoginOpen] = useState(false);
  const [language, setLanguage] = useState(
    typeof window !== "undefined"
      ? localStorage.getItem("preferredLanguage") || "es"
      : "es"
  );
  const [isLangOpen, setIsLangOpen] = useState(false);
  const loginMenuRef = useRef(null);
  const loginMenuMobileRef = useRef(null);
  const langMenuRef = useRef(null);
  const navigate = useNavigate();

  useEffect(() => {
    if (language) {
      localStorage.setItem("preferredLanguage", language);
    }
  }, [language]);

  useLayoutEffect(() => {
    const updateHeaderOffset = () => {
      const header = document.querySelector(".home-header");
      const height = header ? Math.ceil(header.getBoundingClientRect().height) : 0;
      document.documentElement.style.setProperty("--home-header-offset", `${height}px`);
    };
    updateHeaderOffset();
    window.addEventListener("resize", updateHeaderOffset);
    let resizeObserver;
    const header = document.querySelector(".home-header");
    if (header && typeof ResizeObserver !== "undefined") {
      resizeObserver = new ResizeObserver(updateHeaderOffset);
      resizeObserver.observe(header);
    }
    return () => {
      window.removeEventListener("resize", updateHeaderOffset);
      document.documentElement.style.removeProperty("--home-header-offset");
      if (resizeObserver) {
        resizeObserver.disconnect();
      }
    };
  }, []);

  const scrollToSection = () => {
    navigate("/");
    setIsMenuOpen(false);
  };

  const handleLoginSelect = () => {
    setIsLoginOpen(false);
    window.location.href = `/login`;
  };

  const GDPRComponent = components[language] || components.es;
  const t = translations[language];

  return (
    <div className="home">
      <Header
        t={t}
        language={language}
        setLanguage={setLanguage}
        isMenuOpen={isMenuOpen}
        setIsMenuOpen={setIsMenuOpen}
        isLoginOpen={isLoginOpen}
        setIsLoginOpen={setIsLoginOpen}
        isLangOpen={isLangOpen}
        setIsLangOpen={setIsLangOpen}
        scrollToSection={scrollToSection}
        handleLoginSelect={handleLoginSelect}
        loginMenuRef={loginMenuRef}
        loginMenuMobileRef={loginMenuMobileRef}
        langMenuRef={langMenuRef}
        hideNav
      />
      <Suspense fallback={<div>Loading...</div>}>
        <GDPRComponent />
      </Suspense>
      <SiteFooter t={t} />
    </div>
  );
};

export default GDPR;
